import styled from 'styled-components';

interface ContainerProps {
  marginRight?: string;
  marginLeft?: string;
}

export const Container = styled.div<ContainerProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  z-index: 1;
  width: 100%;
  min-width: 0;
  max-width: 100%;
  margin-right: ${({ marginRight }) => marginRight ? marginRight : '0'};
  left: ${({ marginLeft }) => marginLeft ? marginLeft : '0'};

  .icon-add {
    position:absolute;
    right: 10px;
    top: 10px;
    z-index: 2000000000;
    font-size: 1.2rem;
    color: var(--background-button-component);
    background-color: var(--bg-color);
    padding: 1px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      filter: brightness(0.7);
    }
  }

  .icon-folder {
      z-index: 2000000000;
      font-size: 1.4rem;
      color: var(--background-button-component);
      background-color: var(--bg-color);
      padding: 2px;
      border-radius: 5px;
      cursor: pointer;
      transition: 0.3s;
      
        &:hover {
          filter: brightness(0.7);
        }
    }

  .icon-add-2 {
    position:absolute;
    right: 10px;
    top: 10px;
    z-index: 2000000000;
    font-size: 1.2rem;
    color: var(--bg-color);
    background-color: var(--background-button-component);
    padding: 1px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      filter: brightness(0.7);
    }
  }

  .add-destaque {
    position:absolute;
    right: 35px;
    top: 10px;
    z-index: 2000000000;
    font-size: 1.125rem;
    color: var(--background-button-component);
    background-color: var(--bg-color);
    padding: 1.1px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      filter: brightness(0.7);
    }
  }

  .add-destaque-golden {
    position:absolute;
    right: 35px;
    top: 10px;
    z-index: 2000000000;
    font-size: 1.125rem;
    color: var(--primary-gold);
    background-color: var(--bg-color);
    padding: 1.1px;
    border-radius: 20px;
    cursor: pointer;
    transition: 0.3s;

    &:hover {
      filter: brightness(0.7);
    }
  }

  .destaque {
    position: absolute;
    top: 10px;
    left: 10px;
    color: var(--bg-color);
    text-shadow: rgba(0,0,0,0.6) 0.1em 0.1em 0.2em;
    font-weight: 600;
    font-size: 0.6rem;
    padding: 0.2rem;
    border-radius: 6px;
    z-index: 454878;
    background: var(--secondary-blue);
  }
  
  .img {
    width: 100%;
    height: 260px;
    min-height: 260px;
    max-height: 260px;
    border-radius: 1rem;
    background-color: rgba(0,0,0, .1);
    cursor: pointer;
    overflow: hidden;
    flex-shrink: 0;

    .carousel-root,
    .carousel,
    .carousel .slider-wrapper,
    .carousel .slider,
    .carousel .slide {
      height: 100%;
    }

    .carousel .slide > div {
      height: 100%;
    }

    .img-build,
    .img-placeholder {
      display: block;
      width: 100%;
      height: 260px;
      max-height: 260px;
      border-radius: 1rem;
      object-fit: cover;
      object-position: center;
    }

    .img-placeholder {
      object-fit: contain;
      padding: 1rem;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.03);
    }
  }
  
  .wrapper {
    display: flex;
    flex-direction: column;
    line-height: 10px;
    width: 100%;
    overflow: hidden !important;

    .address-and-distance {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      -webkit-line-clamp: 1; // número de linhas que você quer exibir 
      -webkit-box-orient: vertical;
      overflow: hidden;
      /* text-overflow: ellipsis; */
      overflow: hidden; 
      line-height: 18px;
      
      .address {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        min-width: 100%;
      }

      .address-build {
        font-size: 0.85rem;
        font-weight: 600;
        margin: 0;
        color: #0E2244;
        max-width: 100%;
        overflow: hidden;
        white-space: normal;
        word-break: break-word;      // se você quiser cortar com ellipsis
        text-overflow: ellipsis;  // precisa disso pra funcionar o "..."
        display: block;      
        min-width: 0;     // ou inline-block se for inline
      }


      .info {
        /* color: #777; */
        font-size: 0.7rem;
        max-width: 20%;
        margin: 0;
      }

    }

    .label-imovel {
      font-size: 0.8rem;
      color: #777;
      font-weight: 500;
    }

    .description {
      /* display: -webkit-box;
      -webkit-line-clamp: 1; // número de linhas que você quer exibir 
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis; */
      /* height: 20px; */
      /* max-width: 280px; */
      /* margin-bottom: 1rem; */
      /* display: -webkit-box;
      -webkit-line-clamp: 1; // número de linhas que você quer exibir 
      -webkit-box-orient: vertical; */
      /* overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap; */
      display: -webkit-box;
      -webkit-line-clamp: 1;
      overflow: hidden !important;
      -webkit-box-orient: vertical; 
      font-size: .85rem;
      font-weight: 400;
      line-height: 18px;
      margin: 0 0 0.5rem;
      width: 100%;
      color: var(--color-font-footer);
      
    }
    
    .period {
      color: var(--background-button-component);
      span {
        font-size: 0.8rem;
      }
      padding-block: 0.5rem;
    }

    .price {
      color: var(--background-button-component);
      padding-block: 0.5rem;
    }
  }
`;